function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { isDeepKey as s } from "../_internal/isDeepKey.js";
import { toKey as u } from "../_internal/toKey.js";
import { toPath as o } from "../util/toPath.js";
function t(i, r, e) {
  if (i == null) return e;
  switch (_typeof(r)) {
    case "string":
      {
        var n = i[r];
        return n === void 0 ? s(r) ? t(i, o(r), e) : e : n;
      }
    case "number":
    case "symbol":
      {
        typeof r == "number" && (r = u(r));
        var _n = i[r];
        return _n === void 0 ? e : _n;
      }
    default:
      {
        if (Array.isArray(r)) return m(i, r, e);
        Object.is(r == null ? void 0 : r.valueOf(), -0) ? r = "-0" : r = String(r);
        var _n2 = i[r];
        return _n2 === void 0 ? e : _n2;
      }
  }
}
function m(i, r, e) {
  if (r.length === 0) return e;
  var n = i;
  for (var f = 0; f < r.length; f++) {
    if (n == null) return e;
    n = n[r[f]];
  }
  return n === void 0 ? e : n;
}
export { t as get };